export const actionTypesName = {
  // INIT
  INIT_SNAPSHOT: 'Project created',
  RESTORE_SNAPSHOT: 'Project restored',
  UNDO: 'Undo changes',

  // Arrows
  PROJECT_ARROWS_ADD: 'Arrow added',
  PROJECT_ARROWS_GRID_POINTS_ADD: 'Arrow grid point added',
  PROJECT_ARROWS_CHANGE_TYPE: 'Arrow type changed',
  PROJECT_ARROWS_CHANGE_VISIBLE: 'Arrow visibility changed',
  PROJECT_ARROWS_CLONE: 'Arrow cloned',
  PROJECT_ARROWS_DELETE: 'Arrow deleted',
  PROJECT_ARROWS_GRID_POINTS_DELETE: 'Arrow point deleted',
  PROJECT_ARROWS_GRID_POINTS_OFFSET_UPDATE: 'Arrow point moved',
  PROJECT_ARROWS_LABEL_UPDATE: 'Arrow label changed',

  // Attachments
  PROJECT_ATTACHMENTS_ADD: 'Attachment added',
  PROJECT_ATTACHMENTS_CLONE: 'Attachment cloned',
  PROJECT_ATTACHMENTS_DELETE: 'Attachment deleted',
  PROJECT_ATTACHMENTS_UPDATE_OFFSET: 'Attachment moved',

  // Blocks
  PROJECT_BLOCKS_ADD: 'Block added',
  PROJECT_BLOCKS_REACTIONS_ADD: 'Block reaction added',
  PROJECT_BLOCKS_COLLAPSED_CHANGE: 'Block collapsed',
  PROJECT_BLOCKS_COMPLETED_CHANGE: 'Block completion changed',
  PROJECT_BLOCKS_CLONE: 'Block cloned',
  PROJECT_BLOCKS_DELETE: 'Block deleted',
  PROJECT_BLOCKS_REACTIONS_DELETE: 'Block reaction deleted',
  PROJECT_BLOCKS_LINK_TO_SYMBOL: 'Block linked to symbol',
  PROJECT_BLOCKS_UNLINK_COLOR: 'Block color unlinked',
  PROJECT_BLOCKS_UNLINK_SYMBOL: 'Block unlinked from symbol',
  PROJECT_BLOCKS_ASSIGNED_MEMBER_UPDATE: 'Block member updated',
  PROJECT_BLOCKS_COLOR_UPDATE: 'Block color updated',
  PROJECT_BLOCKS_CONTENT_UPDATE: 'Block content updated',
  PROJECT_BLOCKS_IMAGE_UPDATE: 'Block image updated',
  PROJECT_BLOCKS_TITLE_UPDATE: 'Block title updated',
  PROJECT_BLOCKS_WIREFRAMES_UPDATE: 'Block wireframes updated',

  // Colors
  PROJECT_COLORS_CREATE: 'Color created',
  PROJECT_COLORS_DELETE: 'Color deleted',
  PROJECT_COLORS_CODE_UPDATE: 'Color code updated',
  PROJECT_COLORS_ORDER_UPDATE: 'Color order updated',
  PROJECT_COLORS_SHOW_IN_LEGEND_UPDATE: 'Color legend visibility updated',
  PROJECT_COLORS_TITLE_UPDATE: 'Color title updated',
  PROJECT_RELATED_COLOR_DELETE: 'Color and related items deleted',

  // Estimates
  PROJECT_ESTIMATES_ESTIMATE_ADD: 'Estimate added',
  PROJECT_ESTIMATES_LINE_ITEM_ADD: 'Estimate line item added',
  PROJECT_ESTIMATES_LINE_ITEM_LINKED_CHANGE: 'Estimate line item link changed',
  PROJECT_ESTIMATES_SETTINGS_CURRENCY_CHANGE: 'Estimate currency changed',
  PROJECT_ESTIMATES_SETTINGS_PUBLIC_CHANGE: 'Estimate visibility changed',
  PROJECT_ESTIMATES_SETTINGS_TAX_ENABLED_CHANGE: 'Estimate tax changed',
  PROJECT_ESTIMATES_SETTINGS_UNITS_CHANGE: 'Estimate units changed',
  PROJECT_ESTIMATES_ESTIMATE_CLONE: 'Estimate cloned',
  PROJECT_ESTIMATES_ESTIMATE_DELETE: 'Estimate deleted',
  PROJECT_ESTIMATES_LINE_ITEM_DELETE: 'Estimate line item deleted',
  PROJECT_ESTIMATES_NODE_VALUE_UPDATE: 'Estimate value updated',
  PROJECT_ESTIMATES_LINE_ITEM_INDEX_UPDATE: 'Estimate line item order updated',
  PROJECT_ESTIMATES_LINE_ITEM_RATE_UPDATE: 'Estimate line item rate updated',
  PROJECT_ESTIMATES_LINE_ITEM_TITLE_UPDATE: 'Estimate line item title updated',
  PROJECT_ESTIMATES_LINE_ITEM_VALUE_UPDATE: 'Estimate line item value updated',
  PROJECT_ESTIMATES_SETTINGS_TAX_VALUE_UPDATE: 'Estimate tax value updated',

  // External Links
  PROJECT_EXTERNAL_LINKS_ADD: 'External link added',
  PROJECT_EXTERNAL_LINKS_LOADING_CHANGE: 'External link loading changed',
  PROJECT_EXTERNAL_LINKS_CLONE: 'External link cloned',
  PROJECT_EXTERNAL_LINKS_DELETE: 'External link deleted',
  PROJECT_EXTERNAL_LINKS_COLOR_UPDATE: 'External link color updated',
  PROJECT_EXTERNAL_LINKS_DATA_UPDATE: 'External link data updated',
  PROJECT_EXTERNAL_LINKS_OFFSET_UPDATE: 'External link moved',

  // Nodes
  PROJECT_NODES_ADD: 'Node added',
  PROJECT_NODES_COLLAPSE_CHANGE: 'Node collapsed',
  PROJECT_NODES_CLONE: 'Node cloned',
  PROJECT_NODES_DELETE: 'Node deleted',
  PROJECT_NODES_FIGMA_PREVIEW_DELETE: 'Node Figma preview deleted',
  PROJECT_NODES_IMAGE_DELETE: 'Node image deleted',
  PROJECT_NODES_FIGMA_PREVIEW_SET: 'Node Figma preview set',
  PROJECT_NODES_IMAGE_SET: 'Node image set',
  PROJECT_NODES_COLOR_UPDATE: 'Node color updated',
  PROJECT_NODES_NOTES_UPDATE: 'Node notes updated',
  PROJECT_NODES_TITLE_UPDATE: 'Node title updated',
  PROJECT_NODES_URL_UPDATE: 'Node URL updated',
  PROJECT_NODES_VARIANT_UPDATE: 'Node variant updated',
  PROJECT_RELATED_DELETE_AND_UNLINK_NODES: 'Nodes deleted and unlinked',

  // Sections
  PROJECT_SECTIONS_ADD: 'Section added',
  PROJECT_SECTIONS_COLLAPSE_CHANGE: 'Section collapsed',
  PROJECT_SECTIONS_COLOR_CHANGE: 'Section color changed',
  PROJECT_SECTION_CHANGE_TEXT_SIZE: 'Section text size changed',
  PROJECT_SECTIONS_CLONE: 'Section cloned',
  PROJECT_SECTIONS_DELETE: 'Section deleted',
  PROJECT_SECTIONS_ORDER_DOWN: 'Section moved down',
  PROJECT_SECTIONS_ORDER_UP: 'Section moved up',
  PROJECT_SECTIONS_UNLINK_COLORS: 'Section colors unlinked',
  PROJECT_SECTIONS_TITLE_UPDATE: 'Section title updated',

  // Settings
  PROJECT_SETTINGS_ESTIMATE_MODE_CHANGE: 'Estimate mode changed',
  PROJECT_SETTINGS_IMAGE_MODE_CHANGE: 'Image mode changed',
  PROJECT_SETTINGS_LEGEND_POSITION_CHANGE: 'Legend position changed',
  PROJECT_SETTINGS_MOBILE_MODE_CHANGE: 'Mobile mode changed',
  PROJECT_SETTINGS_THEME_CHANGE: 'Theme changed',
  PROJECT_SETTINGS_TREE_FRAME_CHANGE: 'Tree frame changed',
  PROJECT_SETTINGS_TREE_TYPE_CHANGE: 'Tree type changed',
  PROJECT_SETTINGS_AVATAR_UPDATE: 'Avatar updated',
  PROJECT_SETTINGS_DEFAULT_COLOR_UPDATE: 'Default color updated',
  PROJECT_SETTINGS_TITLE_UPDATE: 'Project title updated',

  // Sticky Notes
  PROJECT_STICKY_NOTES_ADD: 'Sticky note added',
  PROJECT_STICKY_NOTES_CLONE: 'Sticky note cloned',
  PROJECT_STICKY_NOTES_DELETE: 'Sticky note deleted',
  PROJECT_STICKY_NOTES_COLOR_UPDATE: 'Sticky note color updated',
  PROJECT_STICKY_NOTES_CONTENT_UPDATE: 'Sticky note content updated',
  PROJECT_STICKY_NOTES_OFFSET_UPDATE: 'Sticky note moved',
  PROJECT_STICKY_NOTES_SIZE_UPDATE: 'Sticky note resized',

  // Symbols
  PROJECT_SYMBOLS_ADD: 'Symbol added',
  PROJECT_SYMBOLS_ADD_DEPENDENT: 'Symbol dependent added',
  PROJECT_SYMBOLS_DELETE: 'Symbol deleted',
  PROJECT_RELATED_SYMBOLS_PURGE:
    'Symbol removed from the library, its blocks deleted',
  PROJECT_SYMBOLS_REMOVE_DEPENDENT: 'Symbol dependent removed',
  PROJECT_SYMBOLS_DATA_UPDATE_COLOR: 'Symbol color updated',
  PROJECT_SYMBOLS_DATA_UPDATE_CONTENT: 'Symbol content updated',
  PROJECT_SYMBOLS_DATA_UPDATE_IMAGE: 'Symbol image updated',
  PROJECT_SYMBOLS_UPDATE_ORDER: 'Symbol order updated',
  PROJECT_SYMBOLS_DATA_UPDATE_TITLE: 'Symbol title updated',
  PROJECT_SYMBOLS_DATA_UPDATE_WIREFRAMES: 'Symbol wireframes updated',

  // Tabs
  PROJECT_TABS_ADD: 'Tab added',
  PROJECT_TABS_CLONE: 'Tab cloned',
  PROJECT_TABS_DELETE: 'Tab deleted',
  PROJECT_TABS_ORDER_DOWN: 'Tab moved down',
  PROJECT_TABS_ORDER_UP: 'Tab moved up',
  PROJECT_TABS_TITLE_UPDATE: 'Tab title updated',

  // Tags
  PROJECT_TAGS_ADD: 'Tag added',
  PROJECT_TAGS_NODES_ADD: 'Node added to tag',
  PROJECT_TAGS_DELETE: 'Tag deleted',
  PROJECT_TAGS_NODES_DELETE: 'Node removed from tag',
  PROJECT_TAGS_NODES_DELETE_FOR_ALL: 'Node removed from all tags',
  PROJECT_TAGS_COLOR_UPDATE: 'Tag color updated',
  PROJECT_TAGS_ORDER_UPDATE: 'Tag order updated',
  PROJECT_TAGS_TITLE_UPDATE: 'Tag title updated',

  // Related Action Types
  PROJECT_RELATED_ARROWS_ADD: 'Arrow added',
  PROJECT_RELATED_ATTACHMENTS_ADD: 'Attachment added',
  PROJECT_RELATED_BLOCKS_ADD: 'Block added',
  PROJECT_RELATED_ESTIMATES_ADD: 'Estimate added',
  PROJECT_RELATED_EXTERNAL_LINKS_ADD: 'External link added',
  PROJECT_RELATED_NODES_ADD: 'Node added',
  PROJECT_RELATED_SECTIONS_ADD: 'Section added',
  PROJECT_RELATED_STICKY_NOTES_ADD: 'Sticky note added',
  PROJECT_RELATED_TABS_ADD: 'Tab added',
  PROJECT_RELATED_ARROWS_CLONE: 'Arrow cloned',
  PROJECT_RELATED_ATTACHMENTS_CLONE: 'Attachment cloned',
  PROJECT_RELATED_BLOCKS_CLONE: 'Block cloned',
  PROJECT_RELATED_ESTIMATES_CLONE: 'Estimate cloned',
  PROJECT_RELATED_EXTERNAL_LINKS_CLONE: 'External link cloned',
  PROJECT_RELATED_NODES_CLONE: 'Node cloned',
  PROJECT_RELATED_SECTIONS_CLONE: 'Section cloned',
  PROJECT_RELATED_STICKY_NOTES_CLONE: 'Sticky note cloned',
  PROJECT_RELATED_TABS_CLONE: 'Tab cloned',
  PROJECT_RELATED_NODES_COLLAPSE: 'Node collapsed',
  PROJECT_RELATED_SECTIONS_COLLAPSE: 'Section collapsed',
  PROJECT_RELATED_ARROWS_DELETE: 'Arrow deleted',
  PROJECT_RELATED_ATTACHMENTS_DELETE: 'Attachment deleted',
  PROJECT_RELATED_BLOCKS_DELETE: 'Block deleted',
  PROJECT_RELATED_ESTIMATES_DELETE: 'Estimate deleted',
  PROJECT_RELATED_EXTERNAL_LINKS_DELETE: 'External link deleted',
  PROJECT_RELATED_NODES_DELETE: 'Node deleted',
  PROJECT_RELATED_SECTIONS_DELETE: 'Section deleted',
  PROJECT_RELATED_STICKY_NOTES_DELETE: 'Sticky note deleted',
  PROJECT_RELATED_TABS_DELETE: 'Tab deleted',
  PROJECT_RELATED_BLOCKS_MOVE: 'Block moved',
  PROJECT_RELATED_NODES_MOVE: 'Node moved',
  PROJECT_RELATED_NODES_SWAP: 'Node swapped',

  // @todo implement batch actions
}
